import { Component } from '@angular/core';
import { Utils } from '../utils/utils';
import { LookupTarget } from '../logo/logo.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: []
})
export class FooterComponent {
  
  get year(): number {
    return new Date().getFullYear();
  }

  get link(): string {
    return Utils.landingPageUrl;
  }

  get lookupTarget(): LookupTarget {
    return LookupTarget.Landing;
  }
}
